import { render, staticRenderFns } from "./MyTabs.vue?vue&type=template&id=01a9f44b&scoped=true&"
import script from "./MyTabs.vue?vue&type=script&lang=js&"
export * from "./MyTabs.vue?vue&type=script&lang=js&"
import style0 from "./MyTabs.vue?vue&type=style&index=0&id=01a9f44b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a9f44b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabs,VTabsItems})
